module.exports = __webpack_public_path__ + "img/MD.54285db6.png";